if (!customElements.get("comparison-cards")) {
  customElements.define(
    "comparison-cards",
    class ComparisonCards extends HTMLElement {
      constructor() {
        super();


        this.scrollToTopButton = this.querySelector("button[data-scroll-to-top]");
        this.bindEvents();


        //console.log("load section")
        const cardElements = this.querySelectorAll(
          "[data-compare-card]"
        );
        //console.log(cardElements);

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const productId = urlParams.get("compare");
        //console.log(productId);

        for (var i = 0; i < cardElements.length; i++) {
          // check each card for id match
          const cardId = cardElements[i].dataset.productId;
          //console.log(cardId);
          if (cardId == productId) {
            cardElements[i].classList.add("featured-card");
          }
        }
      }

      bindEvents() {
        this.scrollToTopButton?.addEventListener("click", this.scrollToTop.bind(this));
      }

      scrollToTop(event) {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  );
}
